export default __webpack_public_path__ + "static/media/Blog2_4.e8b89541.jpg";